// Centralized image URL resolution for product/color images.
//
// Database storage conventions by source:
//   - sanmar : full https URLs for model/flat images; squareImageName is a
//              filename like "DEEP_NAVY.gif" hosted on cdnm.sanmar.com.
//   - sands  : relative paths like "Images/Style/39_fm.jpg" or
//              "Images/ColorSwatch/34000_fm.jpg" hosted on cdn.ssactivewear.com.
//   - ignite : paths under "uploads/..." served by the local API.
//
// resolveImageUrl handles full image paths (frontModelImage, thumbImage, etc.).
// resolveSwatchUrl handles color swatch images (squareImageName).

const SANDS_CDN = "https://cdn.ssactivewear.com/";
const SANMAR_SWATCH_CDN = "https://cdnm.sanmar.com/swatch/gifs/";

const apiUrl = process.env.REACT_APP_LOCALHOST_URL;

export const resolveImageUrl = (path) => {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;
  if (path.includes("uploads")) return apiUrl + path;
  if (path.startsWith("Images/") || path.startsWith("Images\\")) return SANDS_CDN + path;
  return path;
};

export const resolveSwatchUrl = (squareImageName) => {
  if (!squareImageName) return "";
  if (/^https?:\/\//i.test(squareImageName)) return squareImageName;
  if (squareImageName.startsWith("Images/") || squareImageName.startsWith("Images\\"))
    return SANDS_CDN + squareImageName;
  return SANMAR_SWATCH_CDN + squareImageName;
};
